import { Routes } from "../../navigation/routes";
import PageHeader from "ui/components/PageHeader/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Breadcrumb } from "ui/components/Breadcrumb";
import { NOTIFICATION_CALENDAR_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { TabMenu } from "../components/TabMenu";
import { CalendarView } from "./components/CalendarView";

type NotificationCalendarPageCmp = React.FC & { route: string };

const NotificationCalendarPage: NotificationCalendarPageCmp = () => {
  return (
    <div>
      <div className="bg-white rounded-t-md">
        <PageHeader>
          <PageTitle
            title={NOTIFICATION_CALENDAR_PAGE_TITLE.text}
            icon={NOTIFICATION_CALENDAR_PAGE_TITLE.icon}
            iconColor={NOTIFICATION_CALENDAR_PAGE_TITLE.iconColor}
          />
          <Breadcrumb />
        </PageHeader>
        <TabMenu />
      </div>

      <div className="px-4 py-4">
        <CalendarView />
      </div>
    </div>
  );
};

NotificationCalendarPage.route = Routes.NotificationCalendarPageRouter;

export default NotificationCalendarPage;
